import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import TileFactory from "./base";
import VectorLayer from "./layers/vectorLayer";

var TestTile = /*#__PURE__*/function (_TileFactory) {
  _inherits(TestTile, _TileFactory);

  var _super = _createSuper(TestTile);

  function TestTile(option) {
    var _this;

    _classCallCheck(this, TestTile);

    _this = _super.call(this, option);
    _this.parentLayer = option.parent;
    return _this;
  }

  _createClass(TestTile, [{
    key: "createTile",
    value: function createTile(tile, initOptions) {
      var sourceLayer = initOptions.sourceLayer;

      if (!sourceLayer) {
        return {
          layers: [],
          layerIDList: []
        };
      }

      var vectorTileLayer = tile.data.layers[sourceLayer];
      var features = vectorTileLayer === null || vectorTileLayer === void 0 ? void 0 : vectorTileLayer.features;

      if (features.length === 0) {
        return {
          layers: [],
          layerIDList: []
        };
      }

      var properties = features[0].properties;
      var text = new VectorLayer({
        layerType: 'PointLayer',
        usage: 'basemap',
        needListen: false
      }).source([properties], {
        parser: {
          type: 'json',
          x: 'textLng',
          y: 'textLat',
          cancelExtent: true
        }
      }).shape('key', 'text').style({
        size: 20,
        color: '#000',
        stroke: '#fff',
        strokeWidth: 2
      });
      var line = new VectorLayer({
        layerType: 'LineLayer',
        usage: 'basemap',
        needListen: false
      }).source({
        type: 'FeatureCollection',
        features: features
      }, {
        parser: {
          type: 'geojson',
          cancelExtent: true
        }
      }).shape('simple').style({
        color: '#000'
      });
      return {
        layers: [line, text],
        layerIDList: [line.id, text.id]
      };
    }
  }]);

  return TestTile;
}(TileFactory);

export { TestTile as default };